import { ThemeProvider } from "@mui/material";
import React from "react";
import { mergeTheme } from "./helpers";
import { Container } from "./styles";
export const VariantBase = ({
  children,
  theme
}) => /*#__PURE__*/React.createElement(Container, {
  "data-qa": "variant-base"
}, /*#__PURE__*/React.createElement(ThemeProvider, {
  theme: mergeTheme(theme)
}, children));
VariantBase.displayName = "VariantBase";